import fp from 'lodash/fp'
import { data } from 'vtj-koodisto/src/vtj/koodisto'
import {
  Koodi,
  Koodisto,
  KoodistoCode,
  KoodistoType,
  KoodistoTypeKey,
} from 'vtj-koodisto/src/vtj/koodisto.type'
import {
  KoodistoError,
  KoodistoTypeError,
} from 'vtj-koodisto/src/vtj/koodisto-errors'

export type KoodistoLanguage = 'fin' | 'swe' | 'eng'

/**
 * @deprecated Please use the getKoodistoCodesByType-function below as it
 * provides more detailed types
 */
export function getKoodistoByType(type: KoodistoType): Koodisto {
  if (data[type] === undefined) {
    throw new KoodistoTypeError({ message: `Koodistoa ${type} ei löydy` })
  }
  return data[type]
}

export function getKoodistoCodesByType<Key extends KoodistoTypeKey>(
  type: Key
): Koodisto<Key> {
  if (data[type] === undefined) {
    throw new KoodistoTypeError({ message: `Koodistoa ${type} ei löydy` })
  }
  return data[type]
}

const isKoodiValidOnDate = (koodi: Koodi, when: Date): boolean => {
  const dateCopy = new Date(when.getTime())
  dateCopy.setHours(0, 0, 0, 0)

  if (
    (koodi.ALKUPVM &&
      new Date(koodi.ALKUPVM).setHours(0, 0, 0, 0) > dateCopy.getTime()) ||
    (koodi.LOPPUPVM !== null &&
      new Date(koodi.LOPPUPVM).setHours(0, 0, 0, 0) < dateCopy.getTime())
  ) {
    return false
  }
  return true
}

export const getCode = (
  type: KoodistoType,
  code: KoodistoCode | null,
  defaultTextType: 'lyhenne' | 'virallinen' = 'lyhenne'
): Koodi => {
  let res: Koodi | undefined
  const codes = fp.filter<Koodi>(
    (k) => k.KOODI_KOODI === code,
    getKoodistoByType(type)
  )

  if (codes) {
    const defaultCode = codes.find(
      (code) => code.NIMITEKSTI_TYYPPI === defaultTextType
    )
    res = defaultCode || codes[0]
  }

  if (res === undefined) {
    throw new KoodistoError({
      message: `Haettua koodia ${type} ${code} ei löytynyt`,
    })
  }
  return res
}

export function checkCodeValidity(
  type: KoodistoType,
  code: KoodistoCode,
  whenShouldBeValid: Date
): boolean {
  const koodi = getCode(type, code)
  return isKoodiValidOnDate(koodi, whenShouldBeValid)
}

export function uiLangToKoodistoLang(lang: string): KoodistoLanguage {
  switch (lang) {
    case 'en':
      return 'eng'
    case 'sv':
      return 'swe'
    default:
      return 'fin'
  }
}

export function getCodeDescription(
  type: KoodistoType,
  code: KoodistoCode | null,
  lang: KoodistoLanguage
): string | null {
  const result = getCode(type, code)
  switch (lang) {
    case 'eng':
      return result.NIMITEKSTI_ENG
    case 'swe':
      return result.NIMITEKSTI_SWE
    case 'fin':
    default:
      return result.NIMITEKSTI_FIN
  }
}
